import { render } from "./Layout.vue?vue&type=template&id=4499a19b&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=4499a19b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4499a19b"]])

export default __exports__